import type { ContentItemDraft } from '~publish/components/ContentItemCard'

export const UNDATED_CONTENT_ITEM_DRAG_SOURCE =
  'calendarUndatedContentItemDraftsSidebar'

export type UndatedContentItemDragData = {
  type: 'contentItem'
  source: typeof UNDATED_CONTENT_ITEM_DRAG_SOURCE
  contentItem: ContentItemDraft
  label: string
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

export function isUndatedContentItemDragData(
  data: unknown,
): data is UndatedContentItemDragData {
  return (
    isRecord(data) &&
    data.type === 'contentItem' &&
    data.source === UNDATED_CONTENT_ITEM_DRAG_SOURCE &&
    isRecord(data.contentItem) &&
    typeof data.contentItem.id === 'string' &&
    typeof data.label === 'string'
  )
}
